module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    attrs: {
      "offset": 4,
      "span": 16
    }
  }, [_c('logo', {
    attrs: {
      "title": _vm.legal.title,
      "primary-color": _vm.primaryColor
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_vm._v(_vm._s(_vm.legal.content))]), _vm._v(" "), (_vm.isUpdated) ? _c('div', {
    staticClass: "last_update"
  }, [_vm._v("Last Updated on "), _c('span', {
    attrs: {
      "id": "last_update"
    }
  }, [_vm._v(_vm._s(_vm.legal.lastUpdate))])]) : _c('div', {
    staticClass: "last_update"
  }, [_vm._v("Never Updated.")]), _vm._v(" "), _c('company', {
    attrs: {
      "name": _vm.footer.companyName,
      "url": _vm.footer.companyUrl,
      "address": _vm.footer.companyAddress,
      "contact": _vm.footer.companyContact,
      "primary-color": _vm.primaryColor
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d2297a0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/assets/pages/Legal/Legal.vue
// module id = 975
// module chunks = 3